import { render, staticRenderFns } from "./BaseSectionHeading.vue?vue&type=template&id=c76441c2&scoped=true&"
import script from "./BaseSectionHeading.vue?vue&type=script&lang=js&"
export * from "./BaseSectionHeading.vue?vue&type=script&lang=js&"
import style0 from "./BaseSectionHeading.vue?vue&type=style&index=0&id=c76441c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c76441c2",
  null
  
)

component.options.__file = "BaseSectionHeading.vue"
export default component.exports